// Cookie Management Utility
class CookieManager {
  static getCookiePreferences() {
    const preferences = localStorage.getItem('cookiePreferences');
    return preferences ? JSON.parse(preferences) : {
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false
    };
  }

  static hasConsent(category) {
    const preferences = this.getCookiePreferences();
    return preferences[category] === true;
  }

  static setCookie(name, value, days = 30) {
    if (!this.hasConsent('necessary') && !['cookiePreferences', 'cookieConsent'].includes(name)) {
      return false;
    }
    
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
    return true;
  }

  static getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  static clearNonEssentialCookies() {
    const preferences = this.getCookiePreferences();
    
    // Clear analytics cookies if not consented
    if (!preferences.analytics) {
      this.deleteCookie('_ga');
      this.deleteCookie('_gid');
      this.deleteCookie('_gat');
    }
    
    // Clear marketing cookies if not consented
    if (!preferences.marketing) {
      this.deleteCookie('_fbp');
      this.deleteCookie('_fbc');
    }
    
    // Clear functional cookies if not consented
    if (!preferences.functional) {
      this.deleteCookie('user_preferences');
      this.deleteCookie('theme');
    }
  }

  static initializeGoogleAnalytics() {
    if (this.hasConsent('analytics')) {
      // Initialize Google Analytics
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'YOUR_GA_TRACKING_ID');
    }
  }

  static initializeMarketing() {
    if (this.hasConsent('marketing')) {
      // Initialize marketing scripts (Facebook Pixel, etc.)
      console.log('Marketing cookies enabled - Initialize marketing scripts');
    }
  }

  static onPreferenceChange() {
    // Clean up cookies based on new preferences
    this.clearNonEssentialCookies();
    
    // Initialize services based on preferences
    this.initializeGoogleAnalytics();
    this.initializeMarketing();
  }
}

export default CookieManager;